module.exports = __webpack_public_path__ + "img/getdataQrCode.03c276c0.png";